import { AlertTriangle } from 'lucide-react';

/**
 * CLAUDE.md Prompt W: rendered on the Xero integration card when the
 * connected token predates the finance.bankstatementsplus.read scope (a
 * 403 from services/xero_bank_statement_sync.py sets
 * finance_scope_reconsent_required on the connection doc, surfaced
 * verbatim by GET /integrations/xero/status). Purely presentational --
 * reuses the page's existing Reconnect button/handler, no new OAuth code
 * path -- so it's a standalone component only to keep this focused banner
 * unit-testable without mounting the rest of IntegrationsPage.jsx.
 */
/**
 * Prompt AA: the finance scope is opt-in (config.XERO_FINANCE_SCOPE_ENABLED,
 * surfaced as status.finance_scope_enabled) -- Reconnect only requests
 * finance.bankstatementsplus.read once Xero has enabled the Finance API for
 * this app. Never tell the operator to reconsent for a scope the OAuth
 * request isn't actually including.
 */
export function shouldShowXeroFinanceScopeReconsentBanner(status) {
  return Boolean(status?.finance_scope_enabled && status?.finance_scope_reconsent_required);
}

export function XeroFinanceScopeReconsentBanner() {
  return (
    <div
      className="mx-6 mb-3 flex items-start gap-2 rounded-md border border-amber-500/40 bg-amber-500/10 p-3 text-sm text-amber-800 dark:text-amber-300"
      data-testid="xero-finance-scope-reconsent-banner"
    >
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
      <div>
        <p className="font-medium">Reconsent required for live Xero bank statement status</p>
        <p className="text-xs mt-0.5">
          The connected Xero token predates the bank-statement-reconciliation scope, so the
          Accounting column and "Not yet coded" filter are still using the older coverage
          inference for this connection. Click Reconnect to re-authorize with the new scope --
          no need to disconnect first.
        </p>
      </div>
    </div>
  );
}
